import * as React from 'react'
import {ReactNode} from 'react'
import {withErrorSubscribe} from './hoc/withErrorSubscribe'
import {ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import FormErrorMessage from './FormErrorMessage'
import {withHint} from './hoc/withHintButton'
import {LeftColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import { RadioGroupProps } from '@mui/material/RadioGroup';
import { FormControlLabel, RadioGroup, Radio, Box } from '@mui/material';
import { RadioProps } from '@mui/material/Radio';
import {createUUID} from '../../../stringHelper/stringHelpers'

export interface PPRadioItemProp {
    label: string
    value: string
    radioProps?: RadioProps
}

interface Props {
    data: PPRadioItemProp[]
}

interface State {
    selectedLabel: string
}

const RadioGroupWithHint = withHint(RadioGroup)

class PPRadioGroup
    extends React.Component<RadioGroupProps & Props & ErrorHandlingFormProps, State> {

    static displayName: string = 'PPRadioGroup'
    groupName: string = ''

    constructor(props: Readonly<RadioGroupProps & Props & ErrorHandlingFormProps>) {
        super(props)
        this.groupName = props.name || createUUID()
        this.state = {
            selectedLabel: '',
        }
    }

    findSelectedLabel(value: string): string {
        let label: string = ''
        this.props.data.forEach((option) => {
            if (option.value === (value)) {
                label = option.label
                return
            }
        })
        return label
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>, value: string): void {
        this.setState({
            selectedLabel: this.findSelectedLabel(value),
        })
        if (this.props.clearErrorMessage) {
            this.props.clearErrorMessage()
        }

        if (this.props.onChange) {
            this.props.onChange(event, value)
        }
    }

    render(): ReactNode {
        const {
            data, hasError, messages, eventKeys, eventEmitter,
            clearErrorMessage, name, row,
            ...rest
        } = this.props

        return <>
            <LeftColumnFlexContainer>
                <RadioGroupWithHint
                    {...rest}
                    row={row}
                    name={this.groupName}
                    onChange={this.handleChange.bind(this)}
                >
                    {
                        data.map((item, i) =>
                            <Box ml={row && i !== 0 ? '15px' : undefined} key={i}>
                                <FormControlLabel
                                    value={item.value}
                                    control={(
                                        <Radio color="primary" {...item.radioProps}/>
                                    )}
                                    label={item.label}
                                />
                            </Box>,
                        )
                    }
                </RadioGroupWithHint>
                {
                    messages &&
                    <FormErrorMessage
                        messages={messages.map((pair) => {
                            return {
                                message: pair.message,
                                params: [this.state.selectedLabel],
                            }
                        })}
                    />
                }
            </LeftColumnFlexContainer>
        </>
    }
}

export default withErrorSubscribe(PPRadioGroup)
